<template>
  <div>
    <T1Breadcrumbs class="mb-24" :homeLink="true" :items="getBreadcrumbs()" />
    <h2 class="font-24 font-r">{{ getParentRegionName() }} - Lista hoteli</h2>
    <a-row>
      <a-col>
        <div class="content-pane content-pane_white mb-48">
          <div class="section-top-bar">
            <div class="section-top-bar__search">
              <span class="d-none d-xs-inline-block pr-8">Wyszukaj:</span>
              <a-input-search style="width: 100%" v-model="searchQuery" />
            </div>
            <div class="section-top-bar__tools" @click="sortItems">
              <span class="mt-2 pr-4"
                >Sortuj <span class="d-none d-xs-inline">wg nazwy</span></span
              >
              <template v-if="sortingAsc">
                <a-icon type="sort-descending" class="font-18" />
              </template>
              <template v-else>
                <a-icon type="sort-ascending" class="font-18" />
              </template>
            </div>
          </div>
          <div class="mb-32">
            <ul class="column-list">
              <li v-for="({ nazwa, url }, idx) in resultQuery" :key="idx">
                <span class="arrow-right"></span
                ><a :href="url" :title="nazwa">{{ nazwa }}</a>
              </li>
            </ul>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import * as CONFIG from "./config.js";
import T1Breadcrumbs from "./T1Breadcrumbs/T1Breadcrumbs";

export default {
  name: "lista-hoteli-content",
  data: () => ({
    url: "/getlistahoteli.json",
    hotelsList: [],
    searchQuery: "",
    sortingAsc: false
  }),
  methods: {
    getBreadcrumbs() {
      let crumbsArr = [];
      crumbsArr.push({ name: "Lista hoteli", link: "" });
      return crumbsArr;
    },
    getParentRegionName() {
      return CONFIG.panstwo_nazwapl;
    },
    sortItems() {
      this.sortingAsc = !this.sortingAsc;
      let sortedArr = this.hotelsList;
      if (this.sortingAsc) {
        sortedArr.sort((a, b) => a.nazwa.localeCompare(b.nazwa));
      } else {
        sortedArr.reverse();
      }
      this.portaleFiltered = sortedArr;
    },
    getGeoTree() {
      return axios
        .get(CONFIG.API_URL + this.url, null, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: "application/json"
          }
        })
        .then(response => {
          return response.data;
        })
        .catch(e => {
          alert("ERROR" + e);
        });
    }
  },
  mounted() {
    let that = this;
    this.getGeoTree().then(data => {
      that.hotelsList = data.MainPage.page.HotelsList;
    });
  },
  computed: {
    resultQuery() {
      if (this.searchQuery) {
        return this.hotelsList.filter(item => {
          return this.searchQuery
            .toLowerCase()
            .split(" ")
            .every(obj => item.nazwa.toLowerCase().includes(obj));
        });
      } else {
        return this.hotelsList;
      }
    }
  },
  components: {
    T1Breadcrumbs
  }
};
</script>

<style lang="scss" scoped>
.section-top-bar {
  border-bottom: 1px solid $gray-10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  padding-bottom: 18px;
  padding-top: 6px;

  &__search {
    @media (max-width: $screen-xxs-max) {
      width: 180px;
    }

    display: flex;
    align-items: center;
    flex: 1 1 auto;
    padding-right: 12px;
    max-width: 400px;
  }

  &__tools {
    @include text-truncate();
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0px 6px;
    user-select: none;
    transition: all ease-in-out 0.2s;

    &:hover {
      background-color: rgba($gray-10, 0.5);
    }
  }
}
.column-list {
  list-style-type: none;
  margin: 0;
  padding: 0;

  @media (min-width: $screen-xs) {
    columns: 2;
  }

  @media (min-width: $screen-lg) {
    columns: 3;
  }

  > li {
    padding: 2px 6px 2px 16px;
    position: relative;

    a {
      color: $text-color-default;

      &:focus,
      &:hover {
        color: $blue-light;
      }
    }
  }
}

.arrow-right {
  border: solid $gray-40;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 2px;
  position: absolute;
  left: 0;
  top: 10px;
  transform: rotate(-45deg);
}
</style>
